<template>
  <div class="small-12 medium-12 large-12 columns">
    <div class="row documento_dados_designacao">
      <div class="small-4 medium-8 large-6 columns show-for-large">
        <div class="row">
          <div class="small-12 medium-4 large-2 columns">
            <h3>Ano</h3>
          </div>
          <div class="small-0 medium-8 large-10 columns">
            <h3>Designação</h3>
          </div>
        </div>
      </div>
      <div class="small-8 medium-4 large-6 columns">
        <div class="row">
          <div class="small-12 medium-12 large-12 columns">
            <h3>Documentos</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.columns {
  padding-left: 0;
  padding-right: 0;
}

.documento_dados_designacao {
  border-bottom: 1px solid #a7a5a5;
}

.documento_dados_designacao .columns{
  padding-left: 0
}

.documento_dados_designacao .row .columns {
  padding-left: 0
}

.documento_dados_designacao h3 {
  font-size: 12px;
  font-family: "Montserrat";
  text-transform: uppercase;
  color: #707475
}
</style>